export const WATCH_SESSION = 'WATCH_SESSION';
export const UNWATCH_SESSION = 'UNWATCH_SESSION';
export const UPDATE_SESSION = 'UPDATE_SESSION';
export const UPDATE_SESSION_DATA = 'UPDATE_SESSION_DATA';
export const UPDATE_SESSION_LIST = 'UPDATE_SESSION_LIST';
export const SET_SESSION_TIMESTAMP = 'SET_SESSION_TIMESTAMP';
export const UPDATE_SESSION_ATTR = 'UPDATE_SESSION_ATTR';

export const SESSION_FLAG_TYPE = {
  videoStart: 1
};

export const CHART_SERIES = ['pressure', 'gps', 'rssi'];
